import { connect } from 'react-redux';

import { selectContentCounts, selectContentCountsUpToDate } from '~selectors/ContentCountsSelector';
import { CompositeSessionInfoSelectors } from '~selectors/SessionInfoSelectors';
import { siteUrlsSelector } from '~selectors/SiteUrlsSelectors';
import { contentCountsUpToDate } from '~src/app/actions/spaces/ContentCountsActions';
import { addContentFavorite, removeContentFavorite } from '~src/app/actions/spaces/FavoritesActions';
import { populateContentBreadcrumbs } from '~src/app/content/breadcrumbs/BreadcrumbHelpers';
import { PublishedConnectionSubspaceName } from '~src/app/state/SpaceInfo';
import { MapDispatchToProps, MapStateToProps } from '~src/app/utils/ConnectUtils';
import { selectCatalogingOnSiteEnabled } from '~src/catalog/selectors/CatalogSelectors';

import { enterPublishedConnectionSubspace } from '../actions/EnterPublishedConnectionSubspaceAction';
import { publishedConnectionCountsRequest } from '../actions/PublishedConnectionCountsRequestAction';
import {
  PublishedConnectionSpace,
  PublishedConnectionSpaceDispatchProps,
  PublishedConnectionSpaceOwnProps,
  PublishedConnectionSpaceStateProps,
} from './PublishedConnectionSpace';

const mapStateToProps: MapStateToProps<PublishedConnectionSpaceStateProps> = (state) => ({
  contentCountsPublishedConnection: selectContentCounts<'publishedConnection'>(state, 'publishedConnection'),
  urls: siteUrlsSelector(state),
  contentCountsUpToDate: selectContentCountsUpToDate(state),
  isServerOrSiteAdmin: CompositeSessionInfoSelectors.currentUserIsSiteOrServerAdminSelector(state),
  areUsersVisible: !CompositeSessionInfoSelectors.isLimitedUserVisibilityEnforced(state),
  catalogingOnSiteEnabled: selectCatalogingOnSiteEnabled(state)
});

const mapDispatchToProps: MapDispatchToProps<PublishedConnectionSpaceDispatchProps, PublishedConnectionSpaceOwnProps> = (dispatch, ownProps) => ({
  addToFavorites: () => {
    dispatch(addContentFavorite(ownProps.publishedConnectionDetailInfo));
  },
  enterSpace: (requestContent: boolean) => {
    dispatch(enterPublishedConnectionSubspace(
      ownProps.publishedConnectionDetailInfo,
      ownProps.subplaceName as PublishedConnectionSubspaceName,
      requestContent
    ));
  },
  fetchUpdatedContentCounts: () => {
    dispatch(publishedConnectionCountsRequest('publishedConnection'));
  },
  markContentCountsUpToDate: () => {
    dispatch(contentCountsUpToDate());
  },
  populateContentBreadcrumbs,
  removeFromFavorites: () => {
    dispatch(removeContentFavorite(ownProps.publishedConnectionDetailInfo));
  },
});

export const ConnectedPublishedConnectionSpace = connect(mapStateToProps, mapDispatchToProps)(PublishedConnectionSpace);
